<template>
  <div class="list">
    <van-nav-bar
      :title="'随堂考试('+list.length+')'"
      left-arrow
      fixed
      @click-left="onClickLeft"
    />
    <van-empty v-if="list.length==0" description="暂无随堂考试" />
    <van-loading style="text-align: center" type="spinner" v-if="loading" color="#1989fa" />
    <van-row v-for="(item,index) in list" :key="index" class="xitem"   justify="space-between">
      <van-col span="24">
        <h4>{{ item.paperdesc }}(总分{{ item.papervalue }})</h4>
        <p>课程名称：{{ item.kcmc }}</p>
        <p>考试开始时间：{{ item.starttime }}</p>
        <p>考试结束时间：{{ item.endtime }}</p>
        <p>考试时长：{{ item.examtime }}(分钟)</p>
        <p>答题开始时间：{{item.examSuitangKs.ksbj=='Y'?item.examSuitangKs.starttime:'未开始'}}</p>
        <p>交卷时间：{{item.examSuitangKs.ssjj=='Y'?item.examSuitangKs.jjsj:'未交卷'}}</p>
      </van-col>
      <van-col span="24">
        <div
          class="enter"
          @click="enterTest(item)"
        >随堂考试<van-icon name="arrow" />
        </div>
      </van-col>
    </van-row>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        list: [],
        loading:true,
        // 查询参数
        queryParams: {
          pageNum: 1,
          pageSize: 10,
          orderColumn:undefined,
          orderState:undefined,
          isfb:'Y'
        },
      }
    },
    created() {
      this.getsuitangks();
    },
    methods: {
      onClickLeft() {
        this.$router.push({ name: 'studentmain'})
      },
      enterTest(item) {
        if(item.examSuitangKs.pcorphone == "1"){
          this.$toast('已在PC端考试')
          return;
        }
        if(item.examSuitangKs.ssjj == "Y"){
          this.$toast('已交卷')
          return;
        }else {
          this.$router.push({ name: 'suitangexam', params: { id: item.examSuitangKs.stksid} });
        }
      },
      getsuitangks()
      {
        let that = this;
        let data = {params:that.queryParams}
        this.$ajax.get('/student/suitangks/liststks',data).then(function (res) {
          if (res.code == 200) {
            that.list = res.rows;
            that.loading = false;
          }
        })
      },
    }
  }
</script>
<style lang="scss" scoped>
  .list{
    margin-top: 4.125rem;
    padding: 0 1.25rem;
    .xitem{
      background-color: #F8F8F8;
      margin-bottom: .9375rem;
      border-radius: 5px;
      padding: .9375rem 1.25rem;
      h4{
        margin: 0;
        line-height: 1.375rem;
        margin-bottom: .5rem;
      }
      p{
        color: #757DA3;
        font-size: .75rem;
        margin: 0;
        margin-top: .125rem;
        line-height: 1.0625rem;
      }
      .enter{
        color: #757DA3;
        display: flex;
        font-size: .875rem;
        justify-content: space-between;
        padding-top: .9375rem;
        margin-top: .625rem;
        position: relative;
        &::after{
          position: absolute;
          width: calc(100% + 2.5rem);
          left: -1.25rem;
          top: 0;
          content: '';
          height: 1px;
          background-color: #EBEBEB;
        }
      }
      span{
        font-size: .75rem;
        &.ing{
          color: #F86969;
        }
        &.end{
          color: #7469F8;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/studentpage/stceyan.vue